import { useCallback } from "react";
import { Roles } from "../roles/types";

export type IdTokenClaims = {
  roles: Roles[];
};

const useIsInRoles = () => {
  // TODO: validate user's role
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const incluyeRoles = useCallback((rolesToCheck?: string[]) => {
    return true;
  }, []);

  return incluyeRoles;
};

export default useIsInRoles;
